import { Map , List } from 'immutable';
import { actionTypes as AlertDevicesViewActionsType } from '../../../actions/Administration/RfidSettingsPage/alertDevicesViewActions.js';

let defaultState = {
  loading: false,
  selectedDeviceApp : null,
  deviceAppsOptions : []
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case AlertDevicesViewActionsType.ADMINISTRATION_RF_SETTINGS_ALERT_DEVICES_FETCH_DEVICE_APPS_IN_PROCESS:
      return state.set('loading', true);

    case AlertDevicesViewActionsType.ADMINISTRATION_RF_SETTINGS_ALERT_DEVICES_FETCH_DEVICE_APPS_READY:
      state = state.set('deviceAppsOptions', action.payload);
      return state.set('loading',false);

    case AlertDevicesViewActionsType.ADMINISTRATION_RF_SETTINGS_ALERT_DEVICES_DEVICE_APP_CHANGED:
      return state.set('selectedDeviceApp', action.payload);

    default:
      return state;
  }

}







